import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Modal,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import cross from "../../assets/img/cross.png";
import { getFCMToken, sendNotification } from "../../api/Api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: "none",
};

const emojiList = ["😀", "😂", "🥳", "👍", "❤️", "🎉", "🚀", "😊", "🔥", "💡"];

const SendAlertsModal = ({ open, handleClose }) => {
  const theme = useTheme();

  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => {
    setHeader("");
    setBody("");
    setLoading(false);
    handleClose();
  };

  const sendPushNotificationtoUser = async (userId) => {
    try {
      const response = await getFCMToken({ id: userId });
      if (response?.data?.fcmToken) {
        const notificationResponse = await sendNotification({
          fcmToken: response.data.fcmToken,
          title: header,
          body,
          id: userId,
          item: "",
        });
        if (notificationResponse?.data?.success) {
          console.log(`Notification sent to user ${userId}:`, notificationResponse.data);
        } else {
          console.error(`Failed to send notification to user ${userId}:`, notificationResponse?.data);
        }
      } else {
        console.error(`No FCM token received for user ${userId}`);
      }
    } catch (error) {
      console.error(`Error in sendPushNotificationtoUser for user ${userId}:`, error);
    }
  };

  const handleSendAlert = async () => {
    setLoading(true);
    const userData = JSON.parse(localStorage.getItem("user_data"));
    if (userData && Array.isArray(userData)) {
      try {
        await Promise.all(userData.map((user) => sendPushNotificationtoUser(user._id)));
        handleCloseModal();
      } catch (error) {
        console.error("Error sending notifications:", error);
      }
    } else {
      console.warn("No valid user data found in local storage");
    }
    setLoading(false);
  };

  const addEmoji = (emoji) => {
    setBody((prev) => prev + emoji);
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="send-alert-modal-title"
    >
      <Box sx={style}>
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: "20px",
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography id="send-alert-modal-title" variant="h6" component="h2">
            Send Customer Alert
          </Typography>
          <Box
            component="img"
            src={cross}
            alt="Close"
            sx={{ width: "30px", height: "30px", cursor: "pointer" }}
            onClick={handleCloseModal}
          />
        </Box>
        <Box sx={{ padding: "20px" }}>
          <TextField
            fullWidth
            label="Header"
            variant="outlined"
            value={header}
            onChange={(e) => setHeader(e.target.value)}
            sx={{ marginBottom: "20px" }}
          />
          <TextField
            fullWidth
            label="Body"
            variant="outlined"
            multiline
            rows={4}
            value={body}
            onChange={(e) => setBody(e.target.value)}
            sx={{ marginBottom: "20px" }}
          />
          <Box sx={{ marginBottom: "20px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
            {emojiList.map((emoji, index) => (
              <Button
                key={index}
                variant="text"
                onClick={() => addEmoji(emoji)}
                sx={{ minWidth: "auto", padding: "5px" }}
              >
                {emoji}
              </Button>
            ))}
          </Box>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSendAlert}
            disabled={loading || !header || !body}
            startIcon={loading && <CircularProgress size={20} />}
          >
            {loading ? "Please wait..." : "Send Alert"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SendAlertsModal;
